import { Divider } from "components/atoms/Divider";
import { Button } from "features/lp/2/components/Button";
import tw, { styled } from "twin.macro";

const colors = {
  darkBlue: "#160847",
  mustardYellow: "#ebd150",
  pink: "#EA26A5",
};

const darkBlueBg = `background: ${colors.darkBlue}`;
const yellowBg = `background: ${colors.mustardYellow}`;
const darkBlueText = `color: ${colors.darkBlue}`;
const yellowText = `color: ${colors.mustardYellow}`;
const pinkText = `color: ${colors.pink}`;

const Wrapper = styled.div`
  padding: 36px 20px 46px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const StyledDivider = styled(Divider)`
  margin: 0;
  margin-top: 4px;
  width: 86%;
  ${yellowBg};
`;

const Description = styled.p`
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 2.13px;
  line-height: 22px;
`;

const Card = styled.div`
  background: #ffffff;
  border: 2px solid #d8b300;
  box-shadow: 0 2px 55px 0 #f8e71c;
  padding: 32px 0px 20px;
  width: 100%;
`;

const Highlight = styled.span`
  font-size: 32px;
  letter-spacing: 4.27px;
  line-height: 43px;
  ${pinkText};
`;

const useStyles = () => {
  return {
    text: tw`font-hira-mincho font-semibold text-center`,
    label: tw`text-xl letter-spacing[2.67px]`,
  };
};

interface Props {
  onClick?: () => void;
  disabled?: boolean;
}

export const PriceInfo = (buttonProps: Props) => {
  const classes = useStyles();
  return (
    <Wrapper css={[darkBlueBg]}>
      <h2 css={[classes.text, classes.label, yellowText]}>料金について</h2>
      <div tw="text-2xs mt-1.5" css={[classes.text, yellowText]}>
        ・・・・・・
      </div>
      <div
        tw="font-size[43px] letter-spacing[5.73px] mt-9"
        css={[classes.text, yellowText]}
      >
        業界最安水準
      </div>
      <StyledDivider />
      <StyledDivider />
      <div
        tw="p-4 flex items-center justify-center mt-4 w-full"
        css={[yellowBg]}
      >
        <div css={[classes.text, classes.label, darkBlueText]}>
          鑑定料金 1分
        </div>
        <div
          tw="font-size[52px] letter-spacing[.87px] ml-1 mr-2"
          css={[classes.text, darkBlueText]}
        >
          100
        </div>
        <div>
          <div css={[classes.text, classes.label, darkBlueText]}>円~</div>
          <div
            tw="text-2xs letter-spacing[1.2px]"
            css={[classes.text, darkBlueText]}
          >
            (税込)
          </div>
        </div>
      </div>
      <div
        tw="text-2xs letter-spacing[1.33px] self-end mt-2.5"
        css={[classes.text, yellowText]}
      >
        ※通話料20円/分が別途かかります
      </div>
      <Description tw="font-hira-mincho font-semibold mt-5">
        独自のシステムを使用しており、占い師さんに自分の電話番号を知られることはありません。
      </Description>
      <Card tw="mt-7">
        <div
          tw="text-xl letter-spacing[2.67px] leading-9"
          css={[classes.text, darkBlueText]}
        >
          今なら新規会員等速で
          <br />
          最大
          <Highlight css={[classes.text]}>3000</Highlight>円分
          <span css={[classes.text, pinkText]}>無料</span>！
          <Button {...buttonProps} tw="mt-4" />
        </div>
      </Card>
    </Wrapper>
  );
};
